var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"de9b941850e1cb586e6552553718f4603eec66ec"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cake-mag@cake-magazine"]={id:"de9b941850e1cb586e6552553718f4603eec66ec"};
      